import { c as _c } from "react/compiler-runtime";
// PhosphorIcon — renders any Phosphor icon by name from a static SVG asset,
// coloured via CSS `mask` + currentColor (see `.phosphor-icon` in globals.css).
//
// Why not import icon components: the icon name is data-driven (from DB widget
// config), so the bundler can't tree-shake to "just the used ones" — importing
// the catalog would bloat the bundle. Masked static SVGs add ~zero JS, fetch
// only the icons actually on a page (tiny, CDN-cached), and scale to the full
// 1,500+ catalog. Assets are generated into public/phosphor by
// scripts/gen-phosphor-svgs.mjs (prebuild). Works in server + client components.

import type { CSSProperties } from "react";
import { resolveIconName } from "@/lib/icons/resolve";
export type IconWeight = "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
type Props = {
  /** Phosphor icon name (PascalCase, e.g. "ShoppingBag") or a legacy alias. */
  name: string | null | undefined;
  weight?: IconWeight;
  className?: string;
  /** When provided, the icon is exposed to assistive tech; otherwise hidden. */
  "aria-label"?: string;
  title?: string;
};
export function PhosphorIcon(t0) {
  const $ = _c(11);
  const {
    name,
    weight: t1,
    className,
    title,
    "aria-label": ariaLabel
  } = t0;
  const weight = t1 === undefined ? "regular" : t1;
  let t2;
  if ($[0] !== name) {
    t2 = resolveIconName(name);
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const resolved = t2;
  if (!resolved) {
    return null;
  }
  const url = `/phosphor/${weight}/${resolved}.svg`;
  const t3 = `phosphor-icon${className ? ` ${className}` : ""}`;
  const t4 = `url("${url}")`;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      "--phi": t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = t5 as CSSProperties;
  const t7 = ariaLabel ? "img" : undefined;
  const t8 = ariaLabel ? undefined : true;
  let t9;
  if ($[4] !== ariaLabel || $[5] !== t3 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== title) {
    t9 = <span className={t3} style={t6} role={t7} aria-label={ariaLabel} aria-hidden={t8} title={title} />;
    $[4] = ariaLabel;
    $[5] = t3;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = title;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}